const heicDecode = require('heic-decode')
const uuid = require('uuid')

if (typeof window !== 'undefined') {
  window.uuid = uuid
  window.heicDecode = heicDecode
  if (window.Worker) {
    window.heicDecodeWorker = new Worker(document.currentScript.src)
  }
} else {
  self.heicDecode = heicDecode
  self.uuid = uuid
  onmessage = function (evt) {
    heicDecode({ buffer: evt.data.content }).then(function (res) {
      postMessage({ type: 'success', data: res, id: evt.data.id })
    }, function (err) {
      postMessage({ type: 'error', data: err.message, id: evt.data.id })
    })
  }
}
